import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import AssistanceFormik from './AssistanceFormik'
import TripHistoryTimingDetails from '../trips/TripHistoryTimingDetails'
import { IAssistanceObject, IAssistanceCategoryObject } from 'src/types'

interface IEditAssistanceModalProps {
  categories: IAssistanceCategoryObject[]
  update: (assistance: IAssistanceObject) => Promise<any>
  getAssistances: () => void
  assistances: any
}

export default class EditAssistanceModal extends React.Component<RouteComponentProps<any> & IEditAssistanceModalProps> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <AssistanceFormik
              onSubmit={this.onSubmit}
              onSuccess={this.onSuccess}
              categories={this.props.categories}
              title='EDIT ASSISTANCE'
              assistance={this.props.assistances[this.props.match.params.id]}
            >
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Save
              </button>
            </AssistanceFormik>
          </div>
        </div>
      </Modal>
    )
  }

  private onSubmit = (values: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      this.props
        .update({
          id: this.props.match.params.id,
          type: values.type,
          categoryId: values.category,
          instruction: values.instruction
        })
        .then(
          (result: any) => {
            this.props.getAssistances()
            resolve()
          },
          (err: any) => {
            reject(err)
          }
        )
    })
  }

  private onSuccess = () => {
    setTimeout(() => {
      this.onCancel()
    }, 1000)
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/assistance')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/EditAssistanceModal.tsx